@if (buildingEquipment(); as buildingEquipment) {
  <div class="maintenance-timers">
    @for (entity of entities(); track entity.id) {
      <wr-maintenance-timer [maintenanceTimer]="entity"
                            [buildingEquipmentId]="buildingEquipment.id"
                            (update)="onUpdate($event)"
                            (delete)="onDelete(entity)"
      ></wr-maintenance-timer>
    }
    @if (creatingEntity()) {
      <wr-maintenance-timer [buildingEquipmentId]="buildingEquipment.id"
                            (update)="onCreate($event)"
                            (editCancel)="creatingEntity.set(false)"></wr-maintenance-timer>
    }
    @if (!creatingEntity() && canCreate()) {
      <div class="new-timer-button"
           role="button"
           tabindex="0"
           (click)="creatingEntity.set(true)"
           (keydown.enter)="creatingEntity.set(true)">
        <nb-icon icon="plus-outline" pack="eva"></nb-icon>
      </div>
    }
  </div>
}
